import React, { useEffect, useState } from "react";
import dummyImg from "../../assets/images/Profile-thumbnail-small.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Button } from "react-bootstrap";
import { format } from "date-fns";

export default function DeactivatedStudentbyInstructor({ fetchApi, linkTo }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const auth = useSelector((state) => state.auth);
  const [allStudents, setAllStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  useEffect(() => {
    const fetchStudents = async () => {
      if (!auth.token) {
        setError("Please log in to view deactivated students.");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);
      try {
        const response = await fetchApi(auth.token);
        if (response?.success) {
          setAllStudents(response.data || []);
        } else {
          throw new Error(response?.message || "Failed to fetch data");
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        toast.error(
          error?.message || "Failed to fetch data. Please try again.",
          {
            position: "top-center",
          }
        );
        setError(error?.message || "Failed to fetch data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchStudents();
  }, [auth.token, fetchApi]);

  const handleViewDetails = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  const totalPages = Math.ceil((allStudents?.length || 0) / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentStudents = Array.isArray(allStudents)
    ? allStudents.slice(startIndex, endIndex)
    : [];

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const getStatusBadge = (roleId) => {
    const roleConfig = {
      3: { label: "Student", class: "status-active" },
    };

    const config = roleConfig[roleId] || {
      label: "Unknown",
      class: "status-default",
    };

    return (
      <span className={`status-badge ${config.class}`}>{config.label}</span>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
    });
  };

   const isValidDate = (date) => {
    return date && !isNaN(new Date(date).getTime());
  };
  return (
    <>
      {isLoading && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
      <style jsx>{`
        .detail-grid {
          display: grid;
          gap: 20px;
        }

        .detail-item {
          background: #f8fafc;
          border-radius: 12px;
          padding: 16px;
          border-left: 4px solid #f05203;
        }

        .detail-label {
          font-size: 0.875rem;
          font-weight: 700;
          color: #1f1f1f;
          margin-bottom: 4px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .detail-value {
          font-size: 1rem;
          font-weight: 500;
          color: #1f2937;
          line-height: 1.5;
        }

        .status-badge {
          display: inline-flex;
          align-items: center;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 500;
          text-transform: capitalize;
        }

        .status-active {
          background: #dbeafe;
          color: #1d4ed8;
        }

        .status-default {
          background: #f3f4f6;
          color: #6b7280;
        }

        .course-list {
          margin: 0;
          padding-left: 20px;
        }

        .course-list li {
          font-size: 1rem;
          font-weight: 500;
          color: #1f2937;
          line-height: 1.5;
        }

        .text-muted {
          color: #6b7280;
          font-size: 1rem;
          font-weight: 500;
        }
      `}</style>

      <div className="d-flex align-item-center justify-content-end d-sm-none">
        <label className="me-2 flex-shrink-0 align-self-center">
          No of Rows
        </label>
        <select
          className="form-control ms-16"
          value={rowsPerPage}
          onChange={handleRowsChange}
          style={{ width: "100px" }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={30}>30</option>
          <option value={40}>40</option>
          <option value={50}>50</option>
        </select>
      </div>
      <div className="table-responsive mb-10">
        <table className="table student-table custom-table align-middle">
          <thead className="position-sticky top-0">
            <tr>
              <th className="ah-text-base" width="10%">
                Sr No.
              </th>
              <th className="ah-text-base" width="20%">
                Name
              </th>
              <th className="ah-text-base" width="20%">
                Email
              </th>
              <th className="ah-text-base" width="20%">
                Deactivated By
              </th>
              {/* <th className="ah-text-base" width="20%">
                Enrolled Courses
              </th> */}
              <th className="ah-text-base" width="20%">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="6">Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="6">
                  <div className="alert alert-danger">Error: {error}</div>
                </td>
              </tr>
            ) : currentStudents.length > 0 ? (
              currentStudents.map((student, index) => (
                <tr key={student.userId}>
                  <td>
                    <div className="counter-block">
                      {startIndex + index + 1}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="img-holder me-15">
                        <img
                          src={
                            process.env.REACT_APP_GALLERY_URL +
                              student?.profile_picture || dummyImg
                          }
                          alt="Student"
                          className="img-fluid"
                          onError={(e) => (e.target.src = dummyImg)}
                        />
                      </div>
                      <strong className="ah-text-sm fw-semibold">
                        {student.fullName}
                      </strong>
                    </div>
                  </td>
                  <td className="fw-medium">{student.email}</td>
                  <td className="fw-medium">
                    <div>
                      <div className="ah-text-sm">
                        {student.deactivatedBy?.userName || "N/A"}{" "}
                        <span className="text-muted ah-text-xs">
                          {"(" + student.deactivatedBy?.roleName + ")" || "N/A"}
                        </span>
                      </div>
                      {/* <div className="ah-text-xs text-muted">
                        {student.deactivatedBy?.roleName || "N/A"}
                      </div> */}
                    </div>
                  </td>
                  {/* <td className="fw-medium">
                    <div className="ah-text-sm">
                      {student.enrolledCourses?.length > 0 ? (
                        <span className="badge bg-primary me-1">
                          {student.enrolledCourses.length} course(s)
                        </span>
                      ) : (
                        "No courses"
                      )}
                    </div>
                  </td> */}
                  <td className="fw-medium">
                    <Button
                      variant="primary"
                      className="fw-semibold no-shadow py-7 ah-text-sm me-2"
                      onClick={() => handleViewDetails(student)}
                    >
                      View Details
                    </Button>
                    {/* <Link
                      to={`${linkTo}?id=${student.userId}`}
                      className="btn btn-secondary fw-semibold no-shadow py-7 ah-text-sm"
                    >
                      Student Details
                    </Link> */}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">
                  <div className="alert alert-info">
                    No deactivated students found.
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center justify-content-sm-between align-items-center custom-pagination-holder">
        <div className="mx-auto">
          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <svg
              style={{ transform: "rotate(-90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Prev
          </button>
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i + 1}
              className={`bg-transparent border-0 ${
                currentPage === i + 1
                  ? "pagination-item active"
                  : "pagination-item"
              } me-2`}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
            <svg
              style={{ transform: "rotate(90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="align-item-center d-none d-sm-flex">
          <label className="me-2 flex-shrink-0 align-self-center">
            No of Rows
          </label>
          <select
            className="form-control ms-16"
            value={rowsPerPage}
            onChange={handleRowsChange}
            style={{ width: "100px" }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>

      {/* Modal for viewing deactivation details */}
      <div
        className={`modal ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          background: "rgba(0,0,0,0.5)",
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                Deactivated Student Details
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {selectedStudent && (
                <div className="detail-grid">
                  <div className="detail-item">
                    <div className="detail-label">Name</div>
                    <div className="detail-value">{selectedStudent.fullName || "N/A"}</div>
                  </div>
                  <div className="detail-item">
                    <div className="detail-label">Email</div>
                    <div className="detail-value">{selectedStudent.email}</div>
                  </div>
                  {/* <div className="detail-item">
                    <div className="detail-label">Role</div>
                    <div className="detail-value">{getStatusBadge(selectedStudent.roleId)}</div>
                  </div> */}
                  <div className="detail-item">
                    <div className="detail-label">Reason for Deactivation</div>
                    <div className="detail-value">{selectedStudent.reason}</div>
                  </div>
                  <div className="detail-item">
                    <div className="detail-label">Deactivation Time</div>
                    <div className="detail-value">
                      {isValidDate(selectedStudent.startTime)
                        ? format(
                            new Date(selectedStudent.startTime),
                            "MM-dd-yyyy"
                          )
                        : "-"}
                    </div>
                  </div>
                  {selectedStudent.endTime && (
                    <div className="detail-item">
                      <div className="detail-label">Deactivation End</div>
                      <div className="detail-value">
                        {formatDate(selectedStudent.endTime)}
                      </div>
                    </div>
                  )}
                  <div className="detail-item">
                    <div className="detail-label">Enrolled Courses</div>
                    <div className="detail-value">
                      {selectedStudent.enrolledCourses &&
                      selectedStudent.enrolledCourses.length > 0 ? (
                        <ul className="course-list">
                          {selectedStudent.enrolledCourses.map(
                            (course, index) => (
                              <li key={index}>{course.courseTitle}</li>
                            )
                          )}
                        </ul>
                      ) : (
                        <span className="text-muted">No enrolled courses</span>
                      )}
                    </div>
                  </div>
                  {selectedStudent.durationDays && (
                    <div className="detail-item">
                      <div className="detail-label">Duration</div>
                      <div className="detail-value">
                        {selectedStudent.durationDays} days,{" "}
                        {selectedStudent.durationHours} hours,{" "}
                        {selectedStudent.durationMinutes} minutes,{" "}
                        {selectedStudent.durationSeconds} seconds
                      </div>
                    </div>
                  )}
                  <div className="detail-item full-width">
                    <div className="detail-label">Reactivation Request by student</div>
                    <div className="detail-value">
                      {selectedStudent?.reactivationRequestDetails?.argument || "No reactivation request"}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <Link
                to={`${linkTo}?id=${selectedStudent?.userId}`}
                className="btn btn-primary"
                onClick={handleCloseModal}
              >
                View Student Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
